module.exports = __webpack_public_path__ + "img/Visa_Brandmark_White_RGB_2021.692f4a96.svg";